module.exports = __webpack_public_path__ + "img/lovoo.1c376cd.svg";